module.exports = __webpack_public_path__ + "static/media/routing.f2d39c77.jpg";